export enum ProcessInstanceStateFilter {
    ShowAll = "ShowAll",
    ShowRunning = "ShowRunning",
    ShowFinished = "ShowFinished",
    ShowSuccessful =  "ShowSuccessful",
    ShowFailed = "ShowFailed",
    ShowFailedNotAcknowledged = "ShowFailedNotAcknowledged"
}
